import React from 'react';

import { Stack } from '@gogame/components';
import { FormField, withForm, SidePageV2 } from '@gogame/form';

import SelectedPreviewGrid from 'scenes/Gallery/components/SelectedPreviewGrid';

import { loadTags } from 'scenes/Gallery/ConversionPages/ConversionPages/sources/fields';

import { TAGS } from './constants';
import { validationSchema } from './schemas';

const BatchAddTagsForm = withForm({
  validationSchema: validationSchema,
  enableReinitialize: true,
})(({ children, title, selectedRows, loading, onClose, onExited, open }) => {
  return (
    <SidePageV2
      onClose={onClose}
      onExited={onExited}
      open={open}
      loading={loading}
      size={'md'}
    >
      <SidePageV2.Title title={title} />
      <SidePageV2.Content>
        <Stack spacing={3} height={'100%'}>
          <Stack>
            <FormField.MultiSelect
              label={'Tags'}
              name={TAGS}
              source={loadTags}
              required={true}
              padding={0}
            />
          </Stack>
          <Stack overflow={'auto'}>
            <SelectedPreviewGrid
              selectedRows={selectedRows}
              heightCover={true}
            />
          </Stack>
        </Stack>
      </SidePageV2.Content>
      <SidePageV2.Actions>
        <SidePageV2.CloseButton />
        <SidePageV2.SubmitButton />
      </SidePageV2.Actions>
      {children}
    </SidePageV2>
  );
});

export default BatchAddTagsForm;
